import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import {Ellipsis} from "@FRAMEWORK/ui/desktop/text";

const Wrap = styled.div`
	table + h4 {
		margin-top: 40px;
	}
`;
const SubTitle = styled.h4`
	position: relative;
	margin-bottom: 20px;
	line-height: 1;
	font-size: var(--medium-size);
	color: var(--emp-color);
	> span {
		padding: 0 3px;
		font-size: var(--default-size);
		color: var(--gray-color);
	}
`;
const NotiBox = styled.div`
	padding: 40px;
	margin-top: 40px;
	background: #f3f3f3;
`;
const InfoTitle = styled.h5`
	position: relative;
	display: flex;
	align-items: center;
	line-height: 1;
	font-size: var(--default-size);
	color: var(--emp-color);
	&::before {
		display: inline-block;
		width: 18px;
		height: 19px;
		padding-right: 10px;
		background: url(${SpriteImage}) no-repeat 0 -266px;
		vertical-align: middle;
		content: "";
	}
`;
const BulletList = styled.ul`
	margin-top: 10px;
	> li + li {
		margin-top: 10px;
	}
`;
const BtnArea = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 40px;
`;
const PointWrap = styled.ul`
	padding: 20px 40px;
	margin-bottom: 40px;
	border: 1px solid var(--line-color);
	> li {
		position: relative;
		display: flex;
		justify-content: space-between;
		&::before {
			position: absolute;
			top: 50%;
			left: -10px;
			display: block;
			width: 4px;
			height: 4px;
			border-radius: 50%;
			background-color: var(--bl-color);
			transform: translateY(-50%);
			content: "";
		}
		> span > em {
			margin-right: 5px;
		}
	}
	> li + li {
		margin-top: 10px;
	}
`;
const PromotionName = styled.a`
	width: fit-content;
	text-align: left;
	text-decoration: underline;
	${Ellipsis(1)}

	&:active, &:hover {
		text-decoration: underline;
	}
`;

const LinkTr = styled.tr`
	cursor: pointer;
`;

const TableWrap = styled.div`
	margin-bottom: 40px;
	table {
		td {
			padding: 0 10px;
		}
	}
`;

export {BtnArea, BulletList, InfoTitle, NotiBox, SubTitle, Wrap, PointWrap, PromotionName, LinkTr, TableWrap};
